import { get, flatten, set } from 'lodash-es'

import APP_CONFIG_CONSTANTS from '@/js/helper/app-config-constants'
import API_CONSTANTS from '@/js/helper/api-constants.js'
// import CONSTANTS from './constants'
import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'

import { parseDataAttributeJson } from '@/js/helper/data-attribute-helper.js'

const configEl = document.getElementById('bu-app-config')
const configJson = configEl ? configEl.getAttribute('config') : '{}'
const configParsed = parseDataAttributeJson(configJson, {
  fallbackId: 'bu-app-config',
  fallbackType: 'bu-app-config',
})

const attributes = get(configParsed, API_CONSTANTS.ATTRIBUTES, {})
set(attributes, ['catalog', FILTER_CONSTANTS.CATALOG_TYPE.ALL], {
  relationships: {
    catalog: {
      data: flatten(
        Object.values(get(attributes, 'catalog', {})).map(
          c => get(c, ['relationships', 'catalog', 'data']),
          [],
        ),
      ),
    },
  },
})
const links = get(configParsed, API_CONSTANTS.LINKS, {})
const relationships = get(configParsed, API_CONSTANTS.RELATIONSHIPS, {})
const langCode = get(attributes, ['language', 'current', 'code'])
const launchPortalActive = get(attributes, ['launchPortal', 'active'], false)
const launchPortalBrand = launchPortalActive
  ? get(attributes, ['launchPortal', 'brand', 'pimBrand'], 'noBrand')
  : 'noBrand'
if (launchPortalActive) {
  document.body.classList.add('launchportal', `launchportal--${launchPortalBrand}`)
}

export default {
  attributes,
  links: {
    [APP_CONFIG_CONSTANTS.AIMEOS_JSON_API]: `${window.location.origin}/api/jsonapi`, // fallback
    ...links,
  },
  relationships,
  langCode,
  launchPortalActive,
  launchPortalBrand,
}
